import React, { useState, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';

import collectionApi from 'src/api/v2/CollectionApi'

const Preset = ({ title, ...props }) => (
  <div
    className="template_dropdown__item"
    {...props}
  >
    {title}
  </div>
)


const Category = ({ presets = [], name = 'POPin templates', onPresetSelect = () => { } }) => {
  const [expanded, setExpanded] = useState(true)
  const setTemplateFactors = useDispatch()

  const titleClass = "template_dropdown__title"
  const titleStyle = expanded ? { color: '#ffce75' } : {}

  const Presets = useMemo(() => () => {
    const onPresetChange = (presetId) => async () => {
      onPresetSelect(presets.find(preset => preset.id === presetId))
      const templateFactors = await collectionApi.getQuestionsByCollectionId(presetId)
      setTemplateFactors({ type: 'SET_TEMPLATE_FACTORS', payload: templateFactors })
    }

    return (
      <>
        {presets.map(({ id, title }) => (
          <Preset
            key={id}
            onClick={onPresetChange(id)}
            title={title}
          />
        ))
        }
      </>
    )
  }, [presets, setTemplateFactors, onPresetSelect])

  const onDropdownClick = () => (
    expanded ? setExpanded(false) : setExpanded(true)
  )

  return (
    <div className="template_dropdown">
      <div onClick={onDropdownClick} style={titleStyle} className={titleClass}>
        {name}
      </div>

      {expanded && <Presets />}
    </div>
  )
}


const BlueSidebar = ({ categories, setCurrentPreset }) => {
  return (
    <div className="blue_sidebar">
      {categories.map(({ name, presets }, index) => (
        <Category
          key={index}
          name={name}
          presets={presets}
          onPresetSelect={setCurrentPreset}
        />
      ))}
    </div>
  )
}


const mapStateToProps = ({ prioritize }) => {
  return {
    templateFactors: prioritize.templateFactors,
    presets: prioritize.presets,
  };
};

export default connect(mapStateToProps, {})(BlueSidebar);
